module.exports = __webpack_public_path__ + "static/media/28-mobile.4053a685.webp";